import { useContext, useMemo } from 'react';

import UsersContext from 'contexts/UsersContext';
import userTypeCheckers from 'contextProviders/SplashScreenProviders/UserAndAccountProviders/UsersProvider/userTypeCheckers';

// Who made a payment: the name recorded with it (`createdByName`), else the
// account user with its `createdBy` id. Undefined when neither is known.
const usePaymentCreatorName = (
  payment: BonusTypes.AdditionalPayments.Payment,
): string | undefined => {
  const { allUsers } = useContext(UsersContext);

  return useMemo(() => {
    const recordedName = payment.createdByName?.trim();
    if (recordedName) {
      return recordedName;
    }
    const user = allUsers.find((u) => u.id === payment.createdBy);
    if (!user || userTypeCheckers.isWallboardUser(user)) {
      return undefined;
    }
    return user.displayName;
  }, [allUsers, payment.createdBy, payment.createdByName]);
};

export default usePaymentCreatorName;
